import React, { useState } from 'react';
import api from '../api/client';
import { Link } from 'react-router-dom'; // Импортируем Link из react-router-dom
import fard from '../assets/img/fard.png';

const ForgotPasswordForm = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const res = await api.post('/api/forgot-password', { email });
            setMessage(res.data.message);
        } catch (error) {
            setMessage(error.response?.data?.message || 'Error requesting password reset');
        }
    };

    return (
        <div className="container">
            <div className="forgot-password">
                <div className="forgot-password__inner">
                    <form id="forgotPasswordForm" onSubmit={handleSubmit}>
                        <div className="container__input">
                            <label className="label">Email Address</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                placeholder="example@mail.com"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>
                        <div id="message">{message}</div>
                        <input type="submit" className="btn btn__big btn__green align-center mt-12" value="Reset Password" />
                        {/* <Link to="/login" className="btn__big btn__white align-center">Back</Link> */}
                    </form>
                    
                </div>

                <div className="illustration"> 
                    <img src={fard} alt="Gardener Illustration" className="illustration_img" />
                </div>
            </div>
        </div>
    );
};

export default ForgotPasswordForm;
